export default __webpack_public_path__ + "static/media/GreyHome.2fec24ec.svg";